import React, { useEffect, useState } from "react";
import { t } from "../../utils/i18n";
import {
  ArrowTopRight,
  PlusIcon,
  TradeIcon,
  IconRecycle,
  IconRefund2Fill,
  IconBxTransferAlt,
  IconArrowDownLeftSquare,
} from "./dashboardIcons";
import DebitCard from "../NewReactComponents/MainWalletCard/DebitCard";
import SendPaymentCard from "../NewReactComponents/AppTaskComponent/SendPaymentCard";
import { getRequest } from "../../utils/httpRequest";
import P2pMini from "../NewReactComponents/AppTaskComponent/P2pMini";
import TradeHistory from "./TradeHistory";
import FeaturedTraders from "./FeaturedTraders";
import CurrencyTrends from "../NewReactComponents/AppTaskComponent/CurrencyTrends";
import { greetUser } from "./helpers";
import BalanceCard from "./BalanceCard";

const Dashboard = (props) => {
  const [appData, setAppData] = useState(null);
  const [activeTab, setActiveTab] = useState("offers");
  const [walletData, setWalletData] = useState(null);
  const [showBalance, setShowBalance] = useState({
    account_balance: true,
    p2p_balance: true,
    crypto_balance: true,
  });

  const fetchAppData = async () => {
    try {
      const data = await getRequest("/api/v1/dashboard/summary");

      setAppData(data);
    } catch (error) {
      console.error("Error fetching wallet data:", error);
    }
  };

  const fetchWalletData = async () => {
    try {
      const data = await getRequest("/api/v1/dashboard/accounts");
      setWalletData(data);
    } catch (error) {
      console.error("Error fetching wallet data:", error);
    }
  };

  useEffect(() => {
    fetchWalletData();
    fetchAppData();
  }, []);

  const renderActiveTabContent = (activeTab) => {
    switch (activeTab) {
      case "offers":
        return (
          <P2pMini
            p2pData={appData?.offers}
            alt_currency={
              walletData?.wallet_balances?.account_balance?.alt_currency
            }
          />
        );
      case "trades":
        return (
          <TradeHistory userTradeHistory={appData?.user_p2p_trade_history} />
        );
      case "featured":
        return (
          <FeaturedTraders
            currency={
              walletData?.wallet_balances?.account_balance?.alt_currency
            }
          />
        );
      default:
        break;
    }
  };

  return (
    <div className="row">
      <div className="col-12 py-3 d-flex align-items-center flex-wrap gap-2">
        <h4 className="dashboard-greetings mb-0">
          {greetUser()}
          <span className="dashboard-username">
            {props.current_user ? props.current_user.split(" ")[0] : t("dashboard.common.user")}{" "}
          </span>{" "}
          <span className="waving-hand">👋</span>
        </h4>
      </div>
      <div className="col-12 col-sm-7 col-md-8 mb-3">
        <div className="grid-container">
          <div className="grid-item">
            <BalanceCard
              title={t("dashboard.balance.account_title")}
              id="dashboard_card_account"
              ethEnabled={props.ethEnabled}
              alt_currency={
                walletData?.wallet_balances?.account_balance?.alt_currency
              }
              showBalance={showBalance.account_balance}
              setShowBalance={() =>
                setShowBalance((prev) => ({
                  account_balance: !prev.account_balance,
                  p2p_balance: !prev.account_balance,
                  crypto_balance: !prev.account_balance,
                }))
              }
              balance={walletData?.wallet_balances?.account_balance?.balance}
              alt_balance={
                walletData?.wallet_balances?.account_balance?.alt_balance
              }
              links={[
                {
                  title: t("dashboard.balance.add_funds"),
                  icon: <PlusIcon />,
                  link: "/add_funds",
                },
                {
                  title: t("dashboard.balance.send_funds"),
                  icon: <TradeIcon />,
                  link: "/send_usd#SendPaymentsModal",
                },
                {
                  title: t("dashboard.balance.view_assets"),
                  icon: <ArrowTopRight />,
                  link: `/wallets/${props.walletId}`,
                },
              ]}
            />
          </div>
          <div className="grid-item">
            <BalanceCard
              title={t("dashboard.balance.p2p_title")}
              id="dashboard_card_p2p"
              ethEnabled={props.ethEnabled}
              alt_currency={
                walletData?.wallet_balances?.account_balance?.alt_currency
              }
              showBalance={showBalance.p2p_balance}
              setShowBalance={() =>
                setShowBalance((prev) => ({
                  ...prev,
                  p2p_balance: !prev.p2p_balance,
                }))
              }
              balance={walletData?.wallet_balances?.p2p_escrow_balance?.balance}
              alt_balance={
                walletData?.wallet_balances?.p2p_escrow_balance?.alt_balance
              }
              links={[
                {
                  title: t("dashboard.balance.create_offer"),
                  icon: <PlusIcon />,
                  link: "/p2p_trades/offers/new?offer_type=buy",
                },
                {
                  title: t("dashboard.balance.trade_usd"),
                  icon: <TradeIcon />,
                  link: "/p2p_trades/offers/search?offer_type=buy",
                },
                {
                  title: t("dashboard.balance.my_trades"),
                  icon: <ArrowTopRight />,
                  link: "/p2p_trades/trades",
                },
              ]}
            />
          </div>
          <div className="grid-item">
            <BalanceCard
              title={t("dashboard.balance.crypto_title")}
              id="dashboard_card_crypto"
              ethEnabled={props.ethEnabled}
              alt_currency={
                walletData?.wallet_balances?.account_balance?.alt_currency
              }
              showBalance={showBalance.crypto_balance}
              setShowBalance={() =>
                setShowBalance((prev) => ({
                  ...prev,
                  crypto_balance: !prev.crypto_balance,
                }))
              }
              balance={
                walletData?.wallet_balances?.crypto_asset_balance?.balance
              }
              balances={
                walletData?.wallet_balances?.crypto_asset_balance?.balances
              }
              alt_balance={
                walletData?.wallet_balances?.crypto_asset_balance?.alt_balance
              }
              links={[
                {
                  title: t("dashboard.balance.send_token"),
                  icon: <IconBxTransferAlt />,
                  link: "/crypto_transfers/send_crypto/new",
                },
                {
                  title: t("dashboard.balance.receive_token"),
                  icon: <IconArrowDownLeftSquare />,
                  link: `/wallets/${props.walletId}/wallet_addresses`,
                },
                {
                  title: t("dashboard.balance.see_more"),
                  icon: <ArrowTopRight />,
                  link: `/wallets/${props.walletId}`,
                },
              ]}
            />
          </div>
          <div className="w-100 mt-3">
            <div className="dashboard-tables bg-white">
              <div className="container-fluid px-0">
                <ul
                  className="nav p2p-history-tab rounded-lg dashboard-remove-border"
                  id="tradeTabs"
                  role="tablist"
                >
                  <li className="nav-item">
                    <a
                      className="btn nav-link active"
                      id="offers-tab"
                      data-toggle="tab"
                      href="#offers"
                      role="tab"
                      aria-controls="offers"
                      aria-selected="true"
                      onClick={() => setActiveTab("offers")}
                    >
                      {" "}
                      {t("dashboard.offers.latest_offers")}
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className="btn nav-link"
                      id="trades-tab"
                      data-toggle="tab"
                      href="#trades"
                      role="tab"
                      aria-controls="trades"
                      aria-selected="false"
                      onClick={() => setActiveTab("trades")}
                    >
                      {t("dashboard.offers.my_trade_history")}
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className="btn  nav-link"
                      id="featured-tab"
                      data-toggle="tab"
                      href="#featured"
                      role="tab"
                      aria-controls="featured"
                      aria-selected="false"
                      onClick={() => setActiveTab("featured")}
                    >
                      {t("dashboard.offers.featured_traders")}
                    </a>
                  </li>
                </ul>
                <div
                  className="px-3 featured dashboard-remove-border-radius"
                  style={{ overflowX: "hidden", minHeight: "530px" }}
                >
                  {renderActiveTabContent(activeTab)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-sm-5 col-md-4 pl-sm-1">
        <div className="dashboard-atm-section">
          <p className="text-white ml-1 mb-1 mt-0">{t("dashboard.debit_card.title")}</p>
          <DebitCard
            currentUser={props.current_user}
            cardId={props.debitCardId}
            canActivateCard={props.canActivateCard}
            cardBalance={props.balance}
          />

          <div className="dashboard-card-bottom mt-3 dashboard-card-buttons">
            <a className="dashboard-badge" href="/cards/requests/new">
              <PlusIcon />
              <span className="text-center">{t("dashboard.debit_card.apply")}</span>
            </a>
            <a
              className="dashboard-badge"
              href={
                props.canActivateCard || props.debitCardId
                  ? "/cards/requests"
                  : "/cards/requests/activate_card"
              }
            >
              <IconRecycle />
              <span className="text-center">{t("dashboard.debit_card.activate")}</span>
            </a>
            <a
              className="dashboard-badge"
              href={
                props.debitCardId
                  ? `/cards/${props.debitCardId}/card_loads/new`
                  : "/cards/requests/fund_card"
              }
            >
              <IconRefund2Fill />
              <span className="text-center">{t("dashboard.debit_card.fund")}</span>
            </a>
          </div>
        </div>
        <div className="dashboard-payment-section mt-3">
          <SendPaymentCard />
        </div>
      </div>
      <div className="col-12 mt-2">
        {walletData?.wallet_balances?.account_balance?.alt_currency && (
          <CurrencyTrends
            alt_currency={
              walletData?.wallet_balances?.account_balance?.alt_currency
            }
          />
        )}
      </div>
    </div>
  );
};

export default Dashboard;
